import React from 'react';
import PropTypes from 'prop-types';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { t } from 'i18next';
import { connect } from 'react-redux';
import {
  reduxForm, Field, change, getFormValues,
} from 'redux-form';
import {
  MDBDropdown,
} from 'mdbreact';
import Modal from 'react-modal';
import {
  formatDisplayDate,
  openInNewTab,
} from '../../utils/func';
import Column from '../ReactComponent/Column';
import Row from '../ReactComponent/Row';
import SortableTableStyled from '../ReactComponent/SortableTableStyled';
import NoDataDecorator from '../ReactComponent/SortableTableStyled/NoDataDecorator';
import Actions from '../../assets/icons/Actions.svg';
import EditBlack from '../../assets/icons/EditBlack.svg';
import DeleteBlack from '../../assets/icons/DeleteBlack.svg';
import {
  FilterContainer,
  PageTitleH1,
  PageDescription,
  ModalTitle,
  Close,
  ModalBody,
  ButtonDiv,
  ActionsContainer,
  FiltersAndTableContainer,
  TableContainer,
  PaginationContainer,
  SearchContainer,
  SearchLabel,
} from './css';
import { Icon as CommonIcon } from '../ReactComponent/Icon';
import { DropdownItem, DropdownItemIcon } from '../ReactComponent/SortableTable/css';
import putReduxUserDetails from './actions';

import { getCompaniesList, getCompanyUsers } from '../../services/companies';
import { removeUserFromCompany } from '../../services/users';
import { putReduxAllCompanies } from '../ManageCompanies/actions';
import PrimaryButton from '../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../lib/ui/buttons/SecondaryButton';
import ModalBoxStyle from '../_styledComponents/ModalBoxStyle';
import { MDBDropdownToggle, StyledMDBDropdownMenu } from '../_styledComponents/MDBDropdownToggle';
import TertiaryButton from '../../lib/ui/buttons/TertiaryButton';
import PlusBlack from '../../assets/icons/PlusBlack.svg';
import TextInput from '../../lib/ui/form_elements/TextInput';
import Search from '../../assets/icons/Search.svg';
import Dropdown from '../../lib/ui/form_elements/Dropdown';

const ManageUsersForm = 'ManageUsers';

const onClickUrl = (url) => () => openInNewTab(url);

const CustomDropdown = ({ openModal, userId }) => (
  <MDBDropdown className="dropdown">
    <MDBDropdownToggle className="border-0">
      <CommonIcon iconSrc={Actions} />
    </MDBDropdownToggle>
    <StyledMDBDropdownMenu className="text-white bg-dark" basic>
      <DropdownItem onClick={() => {
        window.location.href = (`/create-user?userId=${userId}`);
        return window.location.href;
      }}
      >
        <DropdownItemIcon iconSrc={EditBlack} />
        {t('EditUser')}
      </DropdownItem>
      <DropdownItem onClick={() => openModal()}>
        <DropdownItemIcon iconSrc={DeleteBlack} />
        {t('RemoveFromCompany')}
      </DropdownItem>
    </StyledMDBDropdownMenu>
  </MDBDropdown>
);

const columns = [
  {
    id: 1,
    label: 'Action',
    field: 'actions',
    sort: false,
    selected: true,
    default: true,
  },
  {
    id: 2,
    label: 'UsernameEmail',
    field: 'username',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 3,
    label: 'Company',
    field: 'company',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 4,
    label: 'Description',
    field: 'description',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 5,
    label: 'LastLoginDate',
    field: 'lastLogOnDate',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 6,
    label: 'Status',
    field: 'status',
    sort: true,
    selected: false,
    default: false,
  },
];

const ModalContent = ({
  closeModal, handleRemoveFromCompany, unableToDelete, companyName,
}) => (
  <>
    <ModalTitle>{unableToDelete ? t('UnableToDelete') : t('RemoveFromCompany')}</ModalTitle>
    {unableToDelete
      ? (
        <p>
          {t('Contact')}
            &nbsp;
          <a href="mailto:web.support@dayross.com">web.support@dayross.com</a>
            &nbsp;
          {t('ForHelp')}
          .
        </p>
      )
      : (
        <p>
          {t('RemoveFromCompanyPrompt')}
          {' '}
          <strong>{companyName}</strong>
          ?
        </p>
      )}
    <ButtonDiv>
      {unableToDelete ? null
        : (
          <SecondaryButton
            onClick={() => closeModal()}
            className="active min-width"
            showArrow={false}
          >
            {t('Cancel')}
          </SecondaryButton>
        )}
      <PrimaryButton
        onClick={() => (unableToDelete ? closeModal() : handleRemoveFromCompany())}
        className="active min-width"
        showArrow={false}
      >
        {unableToDelete ? t('Ok') : t('RemoveFromCompany')}
      </PrimaryButton>
    </ButtonDiv>
  </>
);

class ManageUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataPerPage: 10,
      // eslint-disable-next-line react/no-unused-state
      activeTab: 0,
      // eslint-disable-next-line react/no-unused-state
      totalPages: [],
      columns,
      modalIsOpen: false,
      companies: [],
      companyNames: [],
      selectedCompanyId: null,
      selectedCompanyName: '',
      itemToDelete: null,
      globalFilterValue: '',
      unableToDelete: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.fetchCompaniesAssociatedToUser();
    }, 200);
  }

  fetchCompaniesAssociatedToUser = async () => {
    const { division, userId, putReduxAllCompanies } = this.props;
    const { data: companies } = await getCompaniesList(division, userId);

    if (companies) {
      const filteredCompanies = companies.filter(
        (company) => company.division === 'truckmate',
      );
      putReduxAllCompanies(filteredCompanies);
      const companyNames = filteredCompanies.map((company) => company.companyName);
      this.setState({ companies: filteredCompanies, companyNames });
      this.sendInitialRequest(filteredCompanies);
    }
  };

  sendInitialRequest = async (companies) => {
    const { dispatch, putReduxUserDetails } = this.props;
    const firstCompany = companies[0];
    const { companyName, companyId } = firstCompany;

    if (companyName && companyId) {
      dispatch(change('ManageUsers', 'selectedCompany', companyName));
      const { data: firstCompanyUsers } = await getCompanyUsers(companyId);
      const convertedData = this.convertDataFormat(
        firstCompanyUsers,
        companyName,
      );
      putReduxUserDetails(convertedData);
      this.setState({
        data: convertedData,
        selectedCompanyId: companyId,
        selectedCompanyName: companyName,
      });
    }
  };

  handleCompanySelect = async (newValue) => {
    const { dispatch, putReduxUserDetails } = this.props;
    const { companies } = this.state;

    dispatch(change('ManageUsers', 'selectedCompany', newValue));

    if (companies) {
      const selectedCompany = companies.filter(
        (company) => company.companyName === newValue,
      );
      const { companyId, companyName } = selectedCompany[0];
      const { data: companyUsers } = await getCompanyUsers(companyId);

      if (companyUsers) {
        const convertedUserData = this.convertDataFormat(
          companyUsers,
          companyName,
        );
        putReduxUserDetails(convertedUserData);
        this.setState({
          data: convertedUserData,
          selectedCompanyId: companyId,
          selectedCompanyName: companyName,
        });
      }
    }
  };

  renderHeader = ({ heading, description }) =>
    // TODO: Extract this to an outer component its used in ManagePickups as well
    (
      <Row style={{ margin: '0 0 32px' }}>
        <Column $tablet={8} $mobile={12} style={{ padding: '0' }}>
          <div>
            <PageTitleH1>{heading}</PageTitleH1>
            <PageDescription>{description}</PageDescription>
          </div>
        </Column>
      </Row>
    );

  handleRemoveFromCompany = async () => {
    const { itemToDelete, selectedCompanyId } = this.state;
    const { division } = this.props;
    const {
      itemData: { username },
    } = itemToDelete;
    const { data } = this.state;
    const oldData = [...data];

    this.setState({ unableToDelete: false });
    this.closeModal();

    // Use username (email) to identify the user in the API
    removeUserFromCompany(division, username, selectedCompanyId)
      .then((response) => {
        if (response && (response.status === 200 || response.status === 204)) {
          const updatedListItems = oldData.filter((item) => item.username !== username);
          this.setState({
            data: updatedListItems,
            itemToDelete: null,
            unableToDelete: false,
          });
          this.fetchCompaniesAssociatedToUser();
        }
      })
      .catch((error) => {
        this.setState({
          unableToDelete: true,
          itemToDelete: null,
          // eslint-disable-next-line react/no-unused-state
          error,
        });
        this.openModal();
      });

    this.resetData();
  };

  resetData = () => {
    this.setState({
      itemToDelete: null,
    });
  };

  convertDataFormat = (companyUsers, companyName) => companyUsers.map((each, index) => ({
    actions: (
      <CustomDropdown openModal={() => this.openModal(each, index)} index={index} userId={each.userId} />
    ),
    username: each.username || 'N/A',
    company: companyName || 'N/A',
    description: each.description || 'N/A',
    lastLogOnDate:
        (each.lastLogOnDate && formatDisplayDate(each.lastLogOnDate)) || 'N/A',
    status: each.isActive ? t('Active') : t('Inactive'),
  }));

  openModal = (each, index) => {
    this.setState({
      modalIsOpen: true,
      itemToDelete: {
        itemData: each,
        index,
      },
    });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false, itemToDelete: null, unableToDelete: false });
  };

  getTotalPages = () => {
    const { dataPerPage, data } = this.state;
    const totalPages = [];
    for (let i = 1; i <= Math.ceil(data.length / dataPerPage); i++) {
      totalPages.push(i);
    }

    // eslint-disable-next-line react/no-unused-state
    this.setState({ totalPages });
  };

  getSuggestions = (value) => {
    const { allUsers } = this.props;
    const inputValue = value.trim();
    const inputLength = inputValue.length;
    const filteredData = inputLength === 0
      ? allUsers
      : allUsers.filter(
        (item) => item && item.username.slice(0, inputLength).toLowerCase() === inputValue.toLowerCase(),
      );
    this.setState({ data: filteredData }, () => this.getTotalPages());
  };

  render() {
    const {
      rendering: {
        fields: { heading, description },
      },
    } = this.props;
    const {
      data,
      modalIsOpen,
      companyNames = [],
      selectedCompanyName,
      globalFilterValue,
      unableToDelete,
    } = this.state;
    return (
      <div>
        <Modal
          isOpen={modalIsOpen}
          style={ModalBoxStyle}
          contentLabel="Modal"
        >
          <Close onClick={() => this.closeModal()} />
          <ModalBody className="justify-content-center">
            <ModalContent
              closeModal={this.closeModal}
              handleRemoveFromCompany={this.handleRemoveFromCompany}
              unableToDelete={unableToDelete}
              companyName={selectedCompanyName}
            />
          </ModalBody>
        </Modal>

        {this.renderHeader({
          heading: heading.value,
          description: description.value,
        })}

        <FiltersAndTableContainer>
          <FilterContainer>
            <Column className="items-max-width">
              <div className="dropdown-companies">
                <Field
                  name="selectedCompany"
                  type="dropdown"
                  label={t('Companies')}
                  component={Dropdown}
                  options={companyNames.map((item) => ({ value: item }))}
                  onChange={(event, newValue) =>
                    this.handleCompanySelect(event, newValue.item)}
                />
              </div>
              <SearchContainer>
                <SearchLabel>{t('SearchUserText')}</SearchLabel>
                <TextInput
                  placeholder={t('PlaceHolderSearchText')}
                  icon={{ src: Search, alt: 'Search', onClick: () => this.getSuggestions(globalFilterValue) }}
                  input={{
                    value: (globalFilterValue || ''),
                    onChange: (event) => {
                      this.setState({ globalFilterValue: event.target.value }, () => { this.getSuggestions(globalFilterValue); });
                    },
                    onKeyDown: (event) => {
                      if (event.charCode === 13 || event.keyCode === 13) {
                        event.preventDefault();
                        event.stopPropagation();
                        this.getSuggestions(globalFilterValue);
                      }
                    },
                  }}
                />
              </SearchContainer>
            </Column>
            <ActionsContainer>
              <TertiaryButton
                label={t('AddNewUser')}
                onClick={onClickUrl('/create-user')}
                size="small"
                className="add-user-button"
                showArrow={false}
                iconSrc={PlusBlack}
                isIconLeftPosition
              />
            </ActionsContainer>
          </FilterContainer>
        </FiltersAndTableContainer>
        <TableContainer>
          <PaginationContainer>
            <NoDataDecorator component={SortableTableStyled} data={data} columns={this.state.columns} />
          </PaginationContainer>
        </TableContainer>
      </div>
    );
  }
}

const mstp = (state) => ({
  formData: getFormValues('ManageUsersForm')(state),
  division: state.profile.division,
  userId: state.profile.userId,
  allUsers: state.user.userDetails,
  selectedCompany:
    state.form.ManageUsersForm
    && state.form.ManageUsersForm.values
    && state.form.ManageUsersForm.values.selectedCompany,
});

const mdtp = (dispatch) => ({
  putReduxUserDetails: (userDetails) => dispatch(putReduxUserDetails(userDetails)),
  putReduxAllCompanies: (companies) => dispatch(putReduxAllCompanies(companies)),
});

ManageUsers = reduxForm({
  form: ManageUsersForm, // a unique identifier for this form
})(ManageUsers);

export default connect(
  mstp,
  mdtp,
)(ManageUsers);

ManageUsers.propTypes = {
  dispatch: PropTypes.func,
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      heading: PropTypes.object,
      description: PropTypes.object,
    }),
  }),
  division: PropTypes.string,
  userId: PropTypes.string,
  allUsers: PropTypes.arrayOf(PropTypes.object),
  putReduxUserDetails: PropTypes.func,
  putReduxAllCompanies: PropTypes.func,
};

CustomDropdown.propTypes = {
  openModal: PropTypes.func,
  userId: PropTypes.string,
};

ModalContent.propTypes = {
  closeModal: PropTypes.func,
  handleRemoveFromCompany: PropTypes.func,
  unableToDelete: PropTypes.bool,
  companyName: PropTypes.string,
};
